import {useMemo} from 'react';
import {Main} from 'app/components/entities/cloud';

export function useEnvFeatures() {
  return useMemo(() => {
    if (typeof CIRRUS_FEATURE_FLAGS !== 'string') {
      return new Set<Main.Feature>();
    }

    const parsed = CIRRUS_FEATURE_FLAGS.split(',') as Main.Feature[];
    return new Set(parsed.filter((flag) => Main.flags.includes(flag)));
  }, []);
}
